import React, {useState, useEffect} from 'react';
import styles from './sheetDetails.module.scss';
import { InboxAPI } from '../inbox.service';
import { KoButton, KoDateFormatter, KoDP, KoEmpty, KoLoader, KoModal, KoTable, KoTag, KoText, KoTextArea, KoTitle, KoToast, KoUserSelect } from 'packages';
import { formatDateRange } from 'shared/utils';
import { KoTicketTable_COLUMNS } from '../constant';
import { useSelector, useDispatch } from 'react-redux';
import { getApprovalCount } from 'shared/store/approvalCountSlice';
export default function SheetDetails({project,userId, getUsersList, setOpenWorkspaceModal, getWorkspaces, dateRange}) {
  const users = useSelector(state => state?.users);
  const [isReject, setRejectModal] = useState(false);
  const [intervals, setIntervals] = useState();
  const [isLoading, setLoading] = useState(false);
  const [logsByDateRange, setLogsByDateRange] = useState();
  const [currentRecord, setCurrentRecord] = useState();
  const [selectedApprover, setSelectedApprover] = useState();
  const [openSubmitModal, setSubmitModal] = useState(false);
  const [totalLogs, setTotalLogs] = useState();
  const [, setworkHourSections] = useState([]);
  const [currentPeriod, setCurrentPeriod] = useState();
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [comments, setComments] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    getIntervals(dateRange());
  }, [project]);



  const getIntervals = (dateObj) => {
    setLoading(true);
    if (project) {
      let q = {
        status:  project?.status,
        ...dateObj
      };
      InboxAPI.getIntervals(userId, project?.workspace, q).then(
        (data) => {
          setLoading(false);
          let cp = currentPeriod ? currentPeriod : data?.intervals[0];
          setCurrentPeriod(cp);
          setIntervals(data?.intervals);
          getWorkLogs(cp?.intervalStart, cp?.intervalEnd, project?.workspace, cp?.status);
        },
        (err) => {
          setLoading(false);
        }
      );
    }
  };

  const getWorkLogs = (startDate, endDate, workspace, status) => {
    setLoading(true);
    const query = {
      startDate: startDate,
      endDate: endDate,
      status: status
    };
   
    if (!workspace) {
      return;
    }
  
    InboxAPI.getAllWorkLogsTime(userId, query, workspace).then(
      (data) => {
        setLoading(false);
        setLogsByDateRange(data);
        let nonticketLogs = data?.nonticketLogs?.logs || [];
        let ticketLogs = data?.ticketLogs?.logs || [];
        const workHourSections = [
          {
            label: "Billable Hours", withTickets: data?.ticketLogs?.totalBillableWorkHours,
            withoutTickets: data?.nonticketLogs?.totalBillableWorkHours,
            total: data?.ticketLogs?.totalBillableWorkHours
          },
          {
            label: "Non-Billable Hours", withTickets: data?.ticketLogs?.totalNonBillableWorkHours,
            withoutTickets: data?.nonticketLogs?.totalNonBillableWorkHours,
            total: data?.ticketLogs?.totalNonBillableWorkHours
          }
        ];
        setworkHourSections(workHourSections);
        setTotalLogs([...nonticketLogs, ...ticketLogs]);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleApprove = (item) => {
    setLoading(true);
    let q = {
      startDate: currentPeriod?.intervalStart,
      endDate: currentPeriod?.intervalEnd
    };
    let b = {
      status: 2,
      userId: userId
    };
    InboxAPI.approveTimesheet(q, b, project?.workspace).then(
      (data) => {
        setLoading(false);
        getWorkspaces(userId, null, true);
        dispatch(getApprovalCount());
        setOpenWorkspaceModal(false);
        KoToast.success(`Timesheet approved successfully!`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  

  const handleReject = () => {
    setLoading(true);
    let obj = {
      status: 3,
      comments: comments,
      userId: userId
    };
    const q={
      startDate: currentPeriod?.intervalStart,
      endDate: currentPeriod?.intervalEnd
    };
    InboxAPI.rejectTimesheet(obj, q, project?.workspace).then(
      (data) => {
        setLoading(false);
        setRejectModal(false);
        getWorkspaces(userId);
        dispatch(getApprovalCount());
        getUsersList();
        setOpenWorkspaceModal(false);
        setComments('');
        KoToast.success(`Timesheet rejected successfully!`);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const sendApprovalRequest = () => {
    if(!selectedApprover){
      KoToast.error(`Please select an approver!`);
      return;
    }
    setLoading(true);
    let data={
      status: 1,
      approver: selectedApprover,
      requestedBy: userId
    };
    let cuPeriod = {startDate: currentPeriod?.intervalStart, endDate: currentPeriod?.intervalEnd};
    InboxAPI.sendApprovalRequest(data, cuPeriod, project?.workspace).then(
      (data) => {
        setLoading(false);
        KoToast.success(`Request sent successfully!`);
        getWorkspaces(userId);
        dispatch(getApprovalCount());
        setSubmitModal(false);
        getUsersList();
        setOpenWorkspaceModal(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const updateCurrentPeriod = (item, workspace) => {
    setCurrentPeriod(item);
    getWorkLogs(item?.intervalStart, item?.intervalEnd, workspace, item?.status);
  };


  return (
    <div className={styles.wrapper}>
      <div className={`${currentPeriod ? styles.periods : styles.periodsNonHover} customTagLinkNonHover`}>
        {isLoading && <KoLoader />}
        {intervals && currentPeriod ? <>
          <div className={styles.periodsList}>
            <div className={styles.periodsListMain}>
              {intervals?.map((inter, index) => {
                return (
                  <div key={index}>
                    <ul>
                      <li onClick={() => updateCurrentPeriod(inter, project?.workspace)} className={`${currentPeriod?.startDate === inter?.startDate ? styles.active : ''}`}>
                        <div className={styles.periodsListWrapper}>
                          {/* {currentPeriod?.intervalId === intervals?.intervalId && <KoIcon width={22} height={22} name={'TicklineOutlined'} />} */}
                          <KoText className={styles.periodsListText} text={`${formatDateRange(inter?.intervalStart, inter?.intervalEnd)}`} />
                        </div>
                        {inter?.status === 0 && <div className={styles.draft}>
                          <KoText text={'Draft'} />
                        </div>}
                        {(inter?.status === 1) && <div className={styles.inprogress}>
                          <KoText text={'Waiting'} />
                        </div>}
                        {(inter?.status === 2) && <div className={styles.approved}>
                          <KoText text={'Approved'} />
                        </div>}
                        {(inter?.status === 3) && <div className={styles.rejected}>
                          <KoText text={'Rejected'} />
                        </div>}
                        {(inter?.status === 4) && <div className={styles.overdue}>
                          <KoText text={'Overdue'} />
                        </div>}
                      </li>
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.table}>
            <div className={`${styles.tablePart} tableCard`}>
              <div className={styles.tableHeader}>
                {currentPeriod &&
              <div className={styles.tableHeaderTitle}>
                <KoTitle text={`Worklogs`} level={5} />
                {logsByDateRange?.approvelRequestedDate && <KoText className={'fs-size-12'} text={`Requested on:`} />}
                {logsByDateRange?.approvelRequestedDate && <KoTag color={ currentPeriod?.status === 1 ? "yellow" : "geekblue"} value={<KoDateFormatter className={'fs-size-12'} data={logsByDateRange?.approvelRequestedDate} />} />}
                {currentPeriod?.status === 2 &&
                <>
                  {logsByDateRange?.approvedDate && <KoText className={'fs-size-12'} text={`Approved at: `} />}
                  {logsByDateRange?.approvedDate && <KoTag className={styles.workLogSummaryItemTag} color="green" value={
                    <KoDateFormatter className={'fs-size-11'} data={logsByDateRange?.approvedDate} />} />}
                </>
                }
                {currentPeriod?.status === 3 ?
                  <>
                    {logsByDateRange?.rejectedDate && <KoText className={'fs-size-12'} text={`Rejected at: `} />}
                    {logsByDateRange?.rejectedDate && <KoTag className={styles.workLogSummaryItemTag} color="red" value={
                      <KoDateFormatter className={'fs-size-11'} data={logsByDateRange?.rejectedDate} /> } />}
                  </>
                  : null
                }
                {currentPeriod?.status === 3 ?
                  <>
                    {logsByDateRange?.rejectedDate && <KoText className={'fs-size-12'} text={`Rejected at: `} />}
                    {logsByDateRange?.rejectedDate && <KoTag className={styles.workLogSummaryItemTag} color="red" value={
                      <KoDateFormatter className={'fs-size-11'} data={logsByDateRange?.rejectedDate} /> } />}
                  </>
                  : null
                }
                {(currentPeriod?.status === 3  || currentPeriod?.status === 2 || currentPeriod?.status === 1) && logsByDateRange?.approverProfile?.firstName &&
                <>
                  <KoText className={styles.userName}  text={currentPeriod?.status === 3 ? "Rejected by: " : currentPeriod?.status === 2 ? "Approved by: " : "Approver : "} />
                  <KoTag className={styles.userTag} color={currentPeriod?.status === 3 ? "red" :  currentPeriod?.status === 2 ? "green" : "yellow" }value={ <div className={`${styles.userTextIcon} fs-size-12`}>
                    <div className={`${styles.circle}  ${logsByDateRange ?
                      logsByDateRange?.approverProfile?.firstName?.charAt(0).toLowerCase() : 'a'}`}>
                      {logsByDateRange?.approverProfile?.['logo'] ?
                        <KoDP logo={logsByDateRange?.approverProfile?.['logo']} className={styles.profile} width={15} height={15} />
                        :
                        <KoText className={`${styles.letter} fs-size-12`} text={logsByDateRange?.approverProfile?.firstName?.charAt(0)} />}
                    </div>
                    <KoText className={styles.userName}  text={`${logsByDateRange?.approverProfile?.firstName ? logsByDateRange?.approverProfile?.firstName : ''} ${logsByDateRange?.approverProfile?.lastName ? logsByDateRange?.approverProfile?.lastName : ''}`}/>
                  </div>} />
                </>
                }
              </div>
                }
              </div>
              <div className={styles.workLogSummary}>
                {currentPeriod?.status === 3 ?
                  <div className={`${styles.panelHeaderTitle} ${styles.panelRejected}`}>
                    <KoText text={`Reason: ${logsByDateRange?.comments}`} className={styles.panelRejectedTag} />
                  </div> : <div>&nbsp;</div>}
                <div className={`${styles.workLogSummaryItem} customTagLinkNonHover`}>
                  <div className={styles.workLogSummaryItemTitle}>
                    <div className={styles.workLogSummaryItemTagWrapper}>
                      <KoText text={`Billable Hours`} className={styles.workLogItemTitle} />
                      <KoTag value={`With Tickets`} color="color-1" custom={true} count={`${logsByDateRange?.ticketLogs?.totalBillableWorkHours ? logsByDateRange?.ticketLogs?.totalBillableWorkHours : '0:00'}`} />
                      <KoTag value={`Without Tickets `} color="color-2" custom={true} count={`${logsByDateRange?.nonticketLogs?.totalBillableWorkHours ? logsByDateRange?.nonticketLogs?.totalBillableWorkHours : '0:00'}`}  />
                      <KoTag value={`Total Hours`} color="draft" custom={true} count={`${logsByDateRange?.totalBillableWorkHours ? logsByDateRange?.totalBillableWorkHours : '0:00'} `} />
                    </div>
                  </div>
                  <div className={styles.workLogSummaryItemTitle}>
                    <div className={styles.workLogSummaryItemTagWrapper}>
                      <KoText text={`Non - Billable Hours`} className={styles.workLogItemTitle} />
                      <KoTag color="color-1" custom={true} value={`With Tickets`} count={`${logsByDateRange?.ticketLogs?.totalNonBillableWorkHours ? logsByDateRange?.ticketLogs?.totalNonBillableWorkHours : '0:00'}`} />
                      <KoTag color="color-2" custom={true} value={`Without Tickets`} count={`${logsByDateRange?.nonticketLogs?.totalNonBillableWorkHours ? logsByDateRange?.nonticketLogs?.totalNonBillableWorkHours : '0:00'}`}  />
                      <KoTag color="draft" custom={true} value={`Total Hours`} count={`${logsByDateRange?.totalNonBillableWorkHours ? logsByDateRange?.totalNonBillableWorkHours : '0:00'}`} />
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.tableHeaderBtns}>
                {currentPeriod?.status === 1 && <KoButton type='primary'  label='Reasign Timesheet' onClick={() => { setCurrentRecord(project); setSubmitModal(true); }} />}
                {currentPeriod?.status === 1 && <KoButton color="danger" variant="solid" label='Reject Timesheet' onClick={() => { setCurrentRecord(project); setRejectModal(true); }} />}
                {currentPeriod?.status === 1 && <KoButton type='primary' label='Approve Timesheet' onClick={() => { setCurrentRecord(project); handleApprove(project); }} />}
              </div>
              <KoTable
                rowKey="workLogId"
                maxHeight={112}
                data={{ columns: KoTicketTable_COLUMNS, rows: totalLogs }}
              />
            </div>
          </div>
        </>: <KoEmpty title={`No logs found`}
          subText={` `} />}
    

        <KoModal
          title={`Cancel Timesheet?`}
          centered
          open={cancelConfirm}
          afterClose={() => { setCurrentRecord(); }}
          handleOk={() => { setCurrentRecord(); setCancelConfirm(false); }}
          onClose={() => { setCurrentRecord(); setCancelConfirm(false); }}
          width={580}
          footer={[
            <KoButton key='cancel' label='Cancel' onClick={() => setCancelConfirm(false)} />,
            <KoButton key='reset' loading={isLoading} color="danger" variant="solid" type='primary' label='Cancel Timesheet' onClick={() => {}} />
          ]}
        >
          {/* {isLoading && <KoLoader circle={false} />} */}
          <div className={styles.suspend}>
            <KoTitle level={5} text={`Are you sure you want to cancel this timesheet?`} />
            <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
          </div>
        </KoModal>
      </div>
      <KoModal
        title={`Reject ${currentRecord?.name?.toUpperCase()}`}
        centered
        open={isReject}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setRejectModal(false); }}
        onClose={() => { setCurrentRecord(); setRejectModal(false); }}
        width={580}
          // maskClosable={false}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setRejectModal(false)} />,
          <KoButton key='reset' loading={isLoading} color="danger" variant="solid" label='Reject' onClick={() => handleReject(currentRecord)} />
        ]}
      >
        {/* {isLoading && <KoLoader circle={false} />} */}
        <div className={styles.suspend}>
          <KoText text={`Are you sure you want to reject the ${currentRecord?.name?.toUpperCase()}?`} />
          <div className={styles.textArea}>
            <KoTextArea showCount maxLength={100} value={comments} onChange={e => setComments(e?.target?.value)} />
          </div>
        </div>
      </KoModal>

      <KoModal
        title={`Reassign ${currentRecord?.name?.toUpperCase()}`}
        centered
        open={openSubmitModal}
        width={600}
        onClose={() => setSubmitModal(false)}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setSubmitModal(false)} />,
          <KoButton key='RequestApproval' loading={isLoading} type='primary' label={'Reassign'}
            onClick={() => sendApprovalRequest()} />
        ]}
      >
        {/* {isLoading && <KoLoader circle={false} />} */}
        <div className={styles.projectManagers}>
          <div className={styles.projectManagersText}>
            <KoTitle level={5} text='Current approver:' />
            {logsByDateRange?.approverProfile?.firstName && <div className={` ${styles.tag} ${styles.panelHeaderTextIconApp} profileChar`}>
              <div className={`${styles.circleDPsmall}  ${logsByDateRange?.approverProfile?.firstName?.charAt(0) ? logsByDateRange?.approverProfile?.firstName?.charAt(0).toLowerCase() :'a'}`}>
                {logsByDateRange?.approverProfile?.logo ?
                  <KoDP logo={logsByDateRange?.approverProfile['logo']} className={styles.profile} width={30} height={30} />
                  :
                  <KoText className={`${styles.letter}`} text={logsByDateRange?.approverProfile?.firstName?.charAt(0)}/>}
              </div>
              <div className={styles.panelHeaderTextWrapper}>
                <KoText text={`${logsByDateRange?.approverProfile?.firstName ? logsByDateRange?.approverProfile?.firstName : ''} ${logsByDateRange?.approverProfile?.lastName ? logsByDateRange?.approverProfile?.lastName : ''}`}className={styles.panelHeaderText} />
                <KoText text={`${logsByDateRange?.approverProfile?.email ? logsByDateRange?.approverProfile?.email : ''}`}className={styles.panelHeaderText} />
              </div>
            </div>}
          </div>
          <div className={styles.approver}>
            <KoText className={styles.approverText} text='Alternatively, you can select a reporting manager to approve this timesheet entry.' />
            <KoUserSelect onChange={v => setSelectedApprover(v)} users={users['data']} placeholder='Select Reporting Manager' />
          </div>
        </div>
      </KoModal>
        
    </div>
  );
}
